// extracted by mini-css-extract-plugin
export var content = "HeaderMinimal-module--content--4a1fb";
export var headerinner = "HeaderMinimal-module--headerinner--0218d";
export var headerouter = "HeaderMinimal-module--headerouter--f3230";
export var logowrappertop = "HeaderMinimal-module--logowrappertop--63d9d";